import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Layout } from "@/components/Layout";
import { Seo } from "@/components/Seo";

const POSTS = [
  {
    tag: "S&OP · Maturity",
    title: "From Reactive to Leading: The Shift That Turns Uncertainty Into Confidence",
    date: "May 2025",
    image: "https://customer-assets.emergentagent.com/job_planning-hub-31/artifacts/cqdmzwcw_aron-yigin-wGR7OXAMeQE-unsplash.jpg",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7456656646572777472",
  },
  {
    tag: "Demand Planning · AI",
    title: "AI is Changing Demand Planning in 2025 — Here's How",
    date: "May 2025",
    image: "https://customer-assets.emergentagent.com/job_planning-hub-31/artifacts/fp02k0vb_ian-taylor-jOqJbvo1P9g-unsplash.jpg",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7456663181990469632",
  },
  {
    tag: "Maturity",
    title: "The Four Stages of Supply Chain Planning Maturity — Which One Is Your Team In?",
    date: "May 2025",
    image: "https://customer-assets.emergentagent.com/job_planning-hub-31/artifacts/t7ugntjj_SCM.jpg",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7459236705875812352",
  },
  {
    tag: "Performance Management",
    title: "You Are Measuring the Wrong Thing",
    date: "May 2025",
    image: "https://customer-assets.emergentagent.com/job_planning-hub-31/artifacts/kqwvh6xc_Warehouse.jpg",
    link: "https://www.linkedin.com/feed/update/urn:li:activity:7460376714783895552",
  },
];

export default function Insights() {
  return (
    <Layout>
      <Seo
        title="Supply Chain Insights & Frameworks | SCMBrain"
        description="Analyst-grade supply chain content across Plan, Source, Make, and Deliver — frameworks and analysis written by practitioners."
        path="/insights"
      />
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20">
        <p className="text-sm uppercase tracking-[0.2em] text-[#1A6B5A] font-semibold mb-4">Insights & Frameworks</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-[#1B3A6B] max-w-2xl leading-tight">
          Analyst-grade content for practitioners. No fluff.
        </h1>
        <p className="mt-5 text-lg text-[#3E577A] max-w-2xl">
          Frameworks and analysis across Plan, Source, Make, and Deliver — written by people who've done the job.
        </p>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-6">
          {POSTS.map((p, i) => (
            <a
              key={i} data-testid={`insight-${i}`} href={p.link} target="_blank" rel="noopener noreferrer"
              className="group relative h-[280px] rounded-sm overflow-hidden block"
            >
              <img src={p.image} alt="" loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0E2547]/90 via-[#0E2547]/55 to-[#0E2547]/30" />
              <div className="relative h-full flex flex-col justify-end p-7">
                <span className="text-xs font-semibold uppercase tracking-wider text-[#5FC9B5]">{p.tag}</span>
                <h3 className="font-heading text-xl font-bold text-white mt-2 leading-snug">{p.title}</h3>
                <div className="mt-3 flex items-center justify-between">
                  <span className="text-xs text-[#C5D2E6]">{p.date}</span>
                  <span className="text-white font-semibold text-sm inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                    Read More <ArrowRight className="h-4 w-4" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-16 bg-[#1B3A6B] rounded-md p-10 text-center">
          <h2 className="font-heading text-2xl font-bold text-white">Not sure where you stand?</h2>
          <p className="text-[#C5D2E6] mt-2">Run the free Intelligent SCM Scan and get a maturity score in 15 minutes.</p>
          <Link to="/scan" className="inline-flex items-center gap-2 mt-6 bg-[#1A6B5A] text-white rounded-sm px-6 py-3 font-semibold">Start Free Assessment <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </section>
    </Layout>
  );
}
